import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, vModelSelect as _vModelSelect, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9f145718"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "holder" }
const _hoisted_2 = { class: "parameters" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, " Pressure ", -1))
const _hoisted_4 = { class: "row" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "no_end" }, ".", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "end" }, "→", -1))
const _hoisted_7 = [
  _hoisted_5,
  _hoisted_6
]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, " Amplitude ", -1))
const _hoisted_9 = { class: "row" }
const _hoisted_10 = ["v-model"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "no_end" }, ".", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "end" }, "→", -1))
const _hoisted_13 = [
  _hoisted_11,
  _hoisted_12
]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, " Time ", -1))
const _hoisted_15 = { class: "row" }
const _hoisted_16 = ["value"]
const _hoisted_17 = ["value"]
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "none" }, ".", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "lower" }, " ＜ ", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "lower_equal" }, " ≤ ", -1))
const _hoisted_21 = [
  _hoisted_18,
  _hoisted_19,
  _hoisted_20
]
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "t", -1))
const _hoisted_23 = ["value"]
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "equal" }, "=", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "bigger" }, " ＜ ", -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "bigger_equal" }, " ≤ ", -1))
const _hoisted_27 = [
  _hoisted_24,
  _hoisted_25,
  _hoisted_26
]
const _hoisted_28 = ["value"]

import SelectorWithCustomInput from '../Components/SelectorWithCustomInput'
import { computed } from 'vue'


export default {
  __name: 'MovementParametersInput',
  props: { modelValue: { } },
  emits: ['input', 'close'],
  setup(__props, { emit: emits }) {

const props = __props;





const value = computed({
  get () {
    return props.modelValue
  },
  set (value) {
    emits('update:modelValue', value)
  }
})

const pressureOptions = [
  { name: 'Hi', value: 'hi' },
  { name: 'Md', value: 'md' },
  { name: 'Lo', value: 'lo' }
]

const amplitudeOptions = [
  { name: 'Cl', value: 'cl' },
  { name: 'Ha', value: 'ha' },
  { name: 'Op', value: 'op' }
]

return (_ctx, _cache) => {
  const _component_unicon = _resolveComponent("unicon")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "close",
      onClick: _cache[0] || (_cache[0] = $event => (emits('close')))
    }, [
      _createVNode(_component_unicon, { name: "times-circle" })
    ]),
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_unref(SelectorWithCustomInput), {
          modelValue: _unref(value).pressure.start,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((_unref(value).pressure.start) = $event)),
          options: pressureOptions
        }, null, 8, ["modelValue"]),
        _withDirectives(_createElementVNode("select", {
          "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((_unref(value).pressure.type) = $event))
        }, _hoisted_7, 512), [
          [_vModelSelect, _unref(value).pressure.type]
        ]),
        (_unref(value).pressure.type === 'end')
          ? (_openBlock(), _createBlock(_unref(SelectorWithCustomInput), {
              key: 0,
              modelValue: _unref(value).pressure.end,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => ((_unref(value).pressure.end) = $event)),
              options: pressureOptions
            }, null, 8, ["modelValue"]))
          : _createCommentVNode("", true)
      ]),
      _hoisted_8,
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_unref(SelectorWithCustomInput), {
          modelValue: _unref(value).amplitude.start,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => ((_unref(value).amplitude.start) = $event)),
          options: amplitudeOptions
        }, null, 8, ["modelValue"]),
        _createTextVNode("% "),
        _createElementVNode("select", {
          "v-model": _unref(value).amplitude.type
        }, _hoisted_13, 8, _hoisted_10),
        _createVNode(_unref(SelectorWithCustomInput), {
          modelValue: _unref(value).amplitude.end,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => ((_unref(value).amplitude.end) = $event)),
          options: amplitudeOptions
        }, null, 8, ["modelValue"])
      ]),
      _hoisted_14,
      _createElementVNode("div", _hoisted_15, [
        (_unref(value).time.leftType !== 'none')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("input", {
                type: "number",
                value: _ctx.time.start
              }, null, 8, _hoisted_16),
              _createTextVNode("ms ")
            ], 64))
          : _createCommentVNode("", true),
        _createElementVNode("select", {
          value: _unref(value).time.leftType
        }, _hoisted_21, 8, _hoisted_17),
        _hoisted_22,
        _createElementVNode("select", {
          value: _unref(value).time.rightType
        }, _hoisted_27, 8, _hoisted_23),
        _createElementVNode("input", {
          type: "number",
          value: _unref(value).time.end
        }, null, 8, _hoisted_28),
        _createTextVNode("ms ")
      ])
    ])
  ]))
}
}

}